//模板管理

const templaApi = {
  // 获取信息
  getInfo:'/ProProtocol/GetInfo',
  // 获取列表
  getList:'/ProProtocol/GetList',
  // 添加
  add:'/ProProtocol/Add',
  // 编辑
  edit:'/ProProtocol/Edit',
  // 删除
  delete:'/ProProtocol/Del',
  // 审核
  ProProtocol:'/ProProtocol/Check',
  // 撤销
  CheckCancel:'/ProProtocol/CheckCancel',



    /*————————————遥测-遥信-遥控-禁用按钮接口————————————*/
    ProTempYCLibEnable:'/ProTempYCLib/Enable',
    ProTempYXLibEnable:'/ProTempYXLib/Enable',
    ProTempYKLibEnable:'/ProTempYKLib/Enable',



    /*————————————遥测点表接口————————————*/
  // 获取列表
  ProTempYCLibGetList:'/ProTempYCLib/GetList',
  // 添加
  ProTempYCLibAdd:'/ProTempYCLib/Add',
  // 编辑
  ProTempYCLibEdit:'/ProTempYCLib/Edit',
  // 删除
  ProTempYCLibDel:'/ProTempYCLib/Del',
  // 导入
  ProTempYCLibImport:'/ProTempYCLib/Import',



  /*————————————遥信点表接口————————————*/
  // 获取列表
  ProTempYXLibGetList:'/ProTempYXLib/GetList',
  // 添加
  ProTempYXLibAdd:'/ProTempYXLib/Add',
  // 编辑
  ProTempYXLibEdit:'/ProTempYXLib/Edit',
  //删除
  ProTempYXLibDel:'/ProTempYXLib/Del',
  //导入
  ProTempYXLibImport:'/ProTempYXLib/Import',



  /*————————————遥控点表接口————————————*/
  //获取列表
  ProTempYKLibGetList:'/ProTempYKLib/GetList',
  //添加
  ProTempYKLibAdd:'/ProTempYKLib/Add',
  //编辑
  ProTempYKLibEdit:'/ProTempYKLib/Edit',
  // 删除
  ProTempYKLibDel:'/ProTempYKLib/Del',
  // 导入
  ProTempYKLibImport:'/ProTempYKLib/Import'
}

export default templaApi
